/**
 * VersioningPolicy (AJIP-16.02.005 · WS10)
 * ---------------------------------------------------------------------
 * Integer versioning per Founder Ruling RD-03.
 */
import {
  InvalidJourneyVersionError,
  UnsupportedVersionError,
  DeprecatedJourneyError,
} from './RegistrationDiscoveryErrors';

const compareVersions = (a, b) => {
  if (!Number.isInteger(a) || !Number.isInteger(b)) {
    throw new InvalidJourneyVersionError('versions must be integers');
  }
  return a - b;
};

const isNewerVersion = (candidate, current) => compareVersions(candidate, current) > 0;

const assertSupportedVersion = (def, supportedVersions) => {
  if (!supportedVersions || !Array.isArray(supportedVersions)) return true;
  if (!supportedVersions.includes(def.journeyVersion)) {
    throw new UnsupportedVersionError(
      `Journey '${def.journeyId}' version ${def.journeyVersion} not in supported set`,
    );
  }
  return true;
};

const assertNotDeprecated = (def) => {
  if (def.deprecationStatus === 'deprecated' || def.deprecationStatus === 'retired') {
    throw new DeprecatedJourneyError(
      `Journey '${def.journeyId}' is ${def.deprecationStatus}`,
      { replacementJourneyId: def.replacementJourneyId },
    );
  }
  return true;
};

const canReplace = (previous, next) => {
  if (previous.journeyId !== next.journeyId) return false;
  return isNewerVersion(next.journeyVersion, previous.journeyVersion);
};

export {
  compareVersions, isNewerVersion,
  assertSupportedVersion, assertNotDeprecated, canReplace,
};
